{
  "enums": {
    "OriginOfCompany": [
      "Incorporated in Malaysia",
      "Incorporated outside Malaysia"
    ],
    "StatusOfCompany": [
      "Private company",
      "Public company"
    ],
    "TypeOfCompany": [
      "Company limited by shares",
      "Company limited by guarantee",
      "Unlimited company",
      "Company without shares"
    ],
    "ApplicationOfSubmissionType": [
      "Ordinary filing",
      "Rectification filing",
      "Rectification filing with court order",
      "Court order filing"
    ],
    "DisclosureOfFinancialStatementsPreparationForCurrentSubmission": [
      "First time preparation of financial statements after incorporation",
      "Subsequent preparation of financial statements"
    ],    
    "TypeOfStatusOfCarryingOnBusiness": [
      "Carrying on business activities",
      "Not carrying on business activities"
    ],
    "TypeOfAuditStatus": [
      "Audited",
      "Unaudited"
    ],
    "TypeOfAuditExemptionCategory": [
      "Threshold-Qualified company",
      "Zero-revenue company",
      "Dormant company"
    ],
    "TypeOfAccountingStandardsApplied": [
      "Malaysian Financial Reporting Standards",
      "Malaysian Private Entities Reporting Standards",
      "Others"
    ],
    "TypeOfSubmission": [
      "FS-MFRS",
      "KFI-MFRS",
      "FS-BNM",
      "KFI-MPERS",
      "FS-MPERS",
      "FS-EPC",
      "KFI-CLBG",
      "FS-CLBG"
    ],
    "TypeOfPresentationCurrency": [
      "Malaysian Ringgit (MYR)"
    ],
    "TypeOfFunctionalCurrency": [
      "Malaysian Ringgit (MYR)",
      "Sao Tome and Principe Dobra (STD)",
      "Afghan Afghani (AFN)",
      "Albanian Lek (ALL)",
      "Algerian Dinar (DZD)",
      "Angola Kwanza (AOA)",
      "Argentine Peso (ARS)",
      "Armenian Dram (AMD)",
      "Aruban Florin (AWG)",
      "Australian Dollar (AUD)",
      "Azerbaijani Manat (AZN)",
      "Bahamian Dollar (BSD)",
      "Bahraini Dinar (BHD)",
      "Bangladeshi Taka (BDT)",
      "Barbadian Dollar (BBD)",
      "Belarusian Ruble (BYN)",
      "Belize Dollar (BZD)",
      "Bermudian Dollar (BMD)",
      "Bhutanese Ngultrum (BTN)",
      "Bolivian Boliviano (BOB)",
      "Bosnia and Herzegovina Convertible Mark (BAM)",
      "Botswana Pula (BWP)",
      "Brazilian Real (BRL)",
      "British Pound Sterling (GBP)",
      "Brunei Dollar (BND)",
      "Bulgarian Lev (BGN)",
      "Burundi Franc (BIF)",
      "Cabo Verde Escudo (CVE)",
      "Cambodian Riel (KHR)",
      "Canadian Dollar (CAD)",
      "Cayman Islands Dollar (KYD)",
      "Chilean Peso (CLP)",
      "Chinese Yuan Renminbi (CNY)",
      "Colombian Peso (COP)",
      "Comorian Franc (KMF)",
      "Congolese Franc (CDF)",
      "Costa Rican Colón (CRC)",
      "Croatian Kuna (HRK)",
      "Cuban Peso (CUP)",
      "Czech Koruna (CZK)",
      "Danish Krone (DKK)",
      "Djiboutian Franc (DJF)",
      "Dominican Peso (DOP)",
      "Egyptian Pound (EGP)",
      "El Salvadoran Colón (SVC)",
      "Eritrean Nakfa (ERN)",
      "Estonian Euro (EUR)",
      "Ethiopian Birr (ETB)",
      "Fijian Dollar (FJD)",
      "Gambian Dalasi (GMD)",
      "Georgian Lari (GEL)",
      "Ghanaian Cedi (GHS)",
      "Gibraltar Pound (GIP)",
      "Guatemalan Quetzal (GTQ)",
      "Guinean Franc (GNF)",
      "Guyanaese Dollar (GYD)",
      "Haitian Gourde (HTG)",
      "Honduran Lempira (HNL)",
      "Hungarian Forint (HUF)",
      "Hong Kong Dollar (HKD)",
      "Icelandic Krona (ISK)",
      "Indian Rupee (INR)",
      "Indonesian Rupiah (IDR)",
      "Iranian Rial (IRR)",
      "Iraqi Dinar (IQD)",
      "Israeli New Shekel (ILS)",
      "International Monetary Fund (IMF) Special Drawing Rights (XDR)",
      "Isle of Man Pound (IMP)",
      "Jamaican Dollar (JMD)",
      "Japanese Yen (JPY)",
      "Jersey Pound (JEP)",
      "Jordanian Dinar (JOD)",
      "Kazakhstani Tenge (KZT)",
      "Kenyan Shilling (KES)",
      "Kuwaiti Dinar (KWD)",
      "Kyrgyzstani Som (KGS)",
      "Korea (South) Won (KRW)",
      "Korea (North) Won (KPW)",
      "Lao Kip (LAK)",
      "Lebanon Pound (LBP)",
      "Lesotho Loti (LSL)",
      "Liberian Dollar (LRD)",
      "Libyan Dinar (LYD)",
      "Macau Pataca (MOP)",
      "Macedonian Denar (MKD)",
      "Madagascar Ariary (MGA)",
      "Malawi Kwacha (MWK)",
      "Maldivian Rufiyaa (MVR)",
      "Mauritian Rupee (MUR)",
      "Mauritania Ouguiya (MRU)",
      "Mexican Peso (MXN)",
      "Moldovan Leu (MDL)",
      "Myanmar Kyat (MMK)",
      "Mongolian Tugrik (MNT)",
      "Moroccan Dirham (MAD)",
      "Mozambican Metical (MZN)",
      "Namibian Dollar (NAD)",
      "Nepalese Rupee (NPR)",
      "Netherlands Antillean Guilder (ANG)",
      "New Zealand Dollar (NZD)",
      "Nigeria Namibian Naira (NGN)",
      "Nicaraguan Córdoba (NIO)",
      "Norwegian Krone (NOK)",
      "Omani Rial (OMR)",
      "Pakistani Rupee (PKR)",
      "Panamanian Balboa (PAB)",
      "Papua New Guinean Kina (PGK)",
      "Paraguayan Guarani (PYG)",
      "Peruvian Sol (PEN)",
      "Philippine Peso (PHP)",
      "Polish Zloty (PLN)",
      "Qatari Riyal (QAR)",
      "Romanian Leu (RON)",
      "Russian Ruble (RUB)",
      "Rwandan Franc (RWF)",
      "Saint Helena Pound (SHP)",
      "Samoan Tala (WST)",
      "São Tomé and Príncipe Dobra (STN)",
      "Saudi Riyal (SAR)",
      "Serbian Dinar (RSD)",
      "Seychellois Rupee (SCR)",
      "Sierra Leonean Leone (SLL)",
      "Singapore Dollar (SGD)",
      "Solomon Islands Dollar (SBD)",
      "Somali Shilling (SOS)",
      "South African Rand (ZAR)",
      "South Sudanese Pound (SSP)",
      "Sri Lankan Rupee (LKR)",
      "Sudanese Pound (SDG)",
      "Surinamese Dollar (SRD)",
      "Swazi Lilangeni (SZL)",
      "Swedish Krona (SEK)",
      "Swiss Franc (CHF)",
      "Syrian Pound (SYP)",
      "Taiwan New Dollar (TWD)",
      "Tajikistani Somoni (TJS)",
      "Tanzanian Shilling (TZS)",
      "Thai Baht (THB)",
      "Tongan Paʻanga (TOP)",
      "Trinidad and Tobago Dollar (TTD)",
      "Tunisian Dinar (TND)",
      "Turkish Lira (TRY)",
      "Turkmenistani Manat (TMT)",
      "Ugandan Shilling (UGX)",
      "Ukrainian Hryvnia (UAH)",
      "United Arab Emirates Dirham (AED)",
      "United States Dollar (USD)",
      "Uruguayan Peso (UYU)",
      "Uzbekistani Som (UZS)",
      "Vanuatu Vatu (VUV)",
      "Venezuelan Bolívar (VES)",
      "Vietnamese Dong (VND)",
      "Yemeni Rial (YER)",
      "Zambian Kwacha (ZMW)",
      "Zimbabwean Dollar (ZWL)"
    ],
    "TypeOfRoundingOfUsedInPreparingFinancialStatements": [
      "Actuals",
      "In thousands ('000')",
      "In millions ('000,000')",
      "In billions ('000,000,000')"
    ],
    "YesNoItemType": [
      "Yes",
      "No"
    ],
    "BankNegaraMalaysiaRegulationStatusType": [
      "Company regulated by Bank Negara Malaysia",
      "Company not regulated by Bank Negara Malaysia"
    ],
    "TypeOfMethodUsedForPreparingStatementOfFinancialPosition": [
      "Current-Noncurrent",
      "Order of liquidity"
    ],
    "TypeOfMethodUsedForPreparingStatementOfProfitOrLoss": [
      "Function of expense",
      "Nature of expense"
    ],
    "TypeOfMethodUsedForPreparingStatementOfComprehensiveIncome": [
      "Before tax",
      "After tax",
      "Not prepared"
    ],
    "TypeOfMethodUsedForPreparingStatementOfCashFlows": [
      "Direct",
      "Indirect"
    ],
    "CountryOfIncorporation": [
      "Malaysia",
      "Singapore",
      "United States",
      "United Kingdom",
      "China",
      "Hong Kong",
      "Australia",
      "Indonesia",
      "Thailand",
      "Others"
    ],
    "BasisOfConsolidationType": [
      "Full consolidation",
      "Proportionate consolidation",
      "Equity method"
    ],
    "ComparativeInformationType": [
      "Comparative information presented",
      "Comparative information not presented",
      "Restated comparative information"
    ],
    "StockExchangeNameType": [
      "Bursa Malaysia Securities Berhad - Main Market",
      "Bursa Malaysia Securities Berhad - ACE Market",
      "Bursa Malaysia Securities Berhad - LEAP Market",
      "Singapore Exchange (SGX)",
      "Hong Kong Stock Exchange (HKEX)",
      "Other foreign exchange"
    ],
    "TypeOfSecuritiesListedType": [
      "Ordinary shares",
      "Preference shares",
      "Warrants",
      "Bonds / Sukuk",
      "Exchange Traded Funds (ETF)",
      "Real Estate Investment Trusts (REIT)"
    ],
    "ComplianceStatusType": [
      "Fully compliant",
      "Non-compliant",
      "Under remediation"
    ],
    "TypeOfNumberOfDirectorsSigningDirectorsReport": [
      "1",
      "2",
      "3",
      "4",
      "5"
    ],
    "TypeOfIdentification": [
      "Federal/State Government Agency-Wilayah Persekutuan",
      "Passport number",
      "Official Receiver ID number",
      "Non-citizen without passport number",
      "MyPR",
      "MyKAS",
      "MyKad",
      "Military ID number",
      "Local Entity Not Registered with SSM: Society",
      "Local Entity Not Registered with SSM: Others Association",
      "Local Entity Not Registered with SSM: Foundation/ Trust Corporation",
      "Local Entity Not Registered with SSM: Co-Operative",
      "LLP Registration No.",
      "Foreign Entity Not Registered with SSM",
      "Federal/State Government Agency-Terengganu",
      "Old IC number",
      "Federal/State Government Agency-Selangor",
      "Police ID number",
      "Federal/State Government Agency-Sarawak",
      "Federal/State Government Agency-Sabah",
      "Federal/State Government Agency-Pulau Pinang",
      "Federal/State Government Agency-Perlis",
      "Federal/State Government Agency-Perak",
      "Federal/State Government Agency-Pahang",
      "Federal/State Government Agency-Negeri Sembilan",
      "Federal/State Government Agency-Melaka",
      "Federal/State Government Agency-Kelantan",
      "Federal/State Government Agency-Kedah",
      "Federal/State Government Agency-Johor",
      "Company Registration No."
    ],
    "TypeOfStatusOfDividend": [
      "Recommended",
      "Declared",
      "Paid",
      "Not mentioned",
      "Mentioned but not recommended"
    ],
    "TypeOfNumberOfDirectorsSigningStatementByDirectors": [
      "1",
      "2",
      "3",
      "4",
      "5"
    ],
    "WhetherDirectorIsAlsoResponsibleForFinancialManagementOfCompany": [
      "Primarily responsible for financial management of the company",
      "Not primarily responsible for financial management of the company"
    ],
    "TypeOfAuditorsOpinion": [
      "Unmodified opinion",
      "Unmodified but emphasis of matter",
      "Modified opinion - Except for",
      "Modified opinion - Disclaimer",
      "Modified opinion - Adverse"
    ],
    "TypesOfDisclosureOnWhetherCompanysSharesAreTraded": [
      "Listed",
      "Not-listed",
      "Delisted"
    ],
    "TypesOfMethodUsedForRepresentingChangesInAnEntitysEquity": [
      "Statement of Changes In Equity",
      "Statement of Retained Earnings"
    ],
    "TypesOfDisclosureOfRegulationAppliedDuringIncorporationOfCompany": [
      "Companies Act 1965 or 2016",
      "Trust Companies Act 1949"
    ],
    "TypesOfDisclosureOnWhetherCompanyInvolvedAsManagementCompanyUnderInterestSchemeAct2016": [
      "Management company under Interest Scheme Act 2016",
      "Not management company under Interest Scheme Act 2016"
    ],
    "TypeOfExchangeListed": [
      "Bursa Malaysia",
      "Bursa Malaysia and foreign stock exchange",
      "Listed in foreign stock exchange only"
    ],
    "TypeOfMarketListedInBursaMalaysia": [
      "Main Market",
      "ACE Market",
      "LEAP Market"
    ],
    "DisclosureOfSecuritiesListingOnShariahCompliantSecuritiesList": [
      "REITs",
      "i-ETFs",
      "Others",
      "Not applicable"
    ],
    "TypeOfExchangeDelisted": [
      "Bursa Malaysia",
      "Bursa Malaysia and foreign stock exchange",
      "Listed in foreign stock exchange only"
    ],
    "TypeOfExchangeFromWhichShareWereDelisted": [
      "Bursa Malaysia",
      "Bursa Malaysia and foreign stock exchange",
      "Listed in foreign stock exchange only"
    ],
    "TypeOfDisclosureOnCategoriesOfObjectsOfCompaniesLimitedByGuarantee": [
      "Promoting any other objects useful for the community or country",
      "Promoting pension or superannuation schemes",
      "Promoting charity",
      "Promoting religion",
      "Promoting science",
      "Promoting art",
      "Promoting commerce and industry",
      "Providing recreation or amusement"
    ],
    "TypeOfDisclosureOnSubCategoriesOfObjectsOfCompaniesLimitedByGuarantee": [
      "Health",
      "Environment",
      "Education",
      "Sports",
      "Research",
      "Social"
    ],
    "TypeOfMalaysianState": [
      "W.P. PUTRAJAYA",
      "W.P. KUALA LUMPUR",
      "W.P. LABUAN",
      "SARAWAK",
      "SABAH",
      "JOHOR",
      "MELAKA",
      "NEGERI SEMBILAN",
      "PAHANG",
      "SELANGOR",
      "PERAK",
      "TERENGGANU",
      "KELANTAN",
      "PULAU PINANG",
      "KEDAH",
      "PERLIS"
    ]
  },
  "patterns": {
    "NewCompanyRegistrationNumber": "^[0-9]{12}$",
    "CompanyRegistrationNumber": "^(?:[1-9][0-9]{0,9}-[A-Z]|[1-9][0-9]{11})$",
    "CourtReferenceNumber": "^ROC[0-9]{13}$"
  },
  "conditionalMappings": {
    "TypeOfCompanyByStatus": {
      "description": "Valid company types based on company status (Companies Act 2016 Section 3)",
      "mappings": {
        "Private company": ["Company limited by shares", "Unlimited company"],
        "Public company": ["Company limited by shares", "Company limited by guarantee", "Unlimited company"]
      }
    },
    "TypeOfCompanyByOrigin": {
      "description": "Valid company types based on origin of company (Malaysian vs foreign incorporated companies)",
      "mappings": {
        "Incorporated in Malaysia": ["Company limited by shares", "Unlimited company"],
        "Incorporated outside Malaysia": ["Company limited by shares", "Unlimited company", "Company without shares"]
      }
    },
    "AuditExemptionByCompanyType": {
      "description": "Available audit exemption categories based on company classification",
      "mappings": {
        "Company limited by shares": ["Threshold-Qualified company", "Zero-revenue company", "Dormant company"],
        "Company limited by guarantee": ["Threshold-Qualified company", "Dormant company"],
        "Unlimited company": ["Threshold-Qualified company", "Zero-revenue company", "Dormant company"]
      }
    },
    "TypeOfSubmissionByAccountingStandard": {
      "description": "Valid submission types based on accounting standards applied",
      "mappings": {
        "Malaysian Financial Reporting Standards": ["FS-MFRS", "KFI-MFRS"],
        "Malaysian Private Entities Reporting Standards": ["FS-MPERS"],
        "Others": ["FS-OTHER"]
      }
    },
    "TypeOfAccountingStandardsAppliedByStatus": {
      "description": "Available accounting standards based on company status",
      "mappings": {
        "Private company": ["Malaysian Financial Reporting Standards", "Malaysian Private Entities Reporting Standards", "Others"],
        "Public company": ["Malaysian Financial Reporting Standards", "Malaysian Private Entities Reporting Standards"]
      }
    },
    "TypeOfSubmissionByStatusAndStandard": {
      "description": "Available type of submission based on company status AND accounting standards applied (2-field filtering - deprecated, use TypeOfSubmissionByStatusTypeAndStandard instead)",
      "mappings": {
        "Public company|Malaysian Financial Reporting Standards": ["KFI-MFRS", "FS-MFRS", "FS-BNM"],
        "Public company|Malaysian Private Entities Reporting Standards": ["KFI-MPERS", "FS-MPERS"],
        "Private company|Malaysian Financial Reporting Standards": ["KFI-MFRS", "FS-MFRS", "FS-EPC"],
        "Private company|Malaysian Private Entities Reporting Standards": ["KFI-MPERS", "FS-MPERS", "FS-EPC"],
        "Private company|Others": ["FS-EPC"],
        "Public company|Others": ["FS-EPC"]
      }
    },
    "TypeOfSubmissionByStatusTypeAndStandard": {
      "description": "Available type of submission based on company status, type of company AND accounting standards applied (3-field filtering) - Temporarily limited to FS-MFRS and FS-MPERS only",
      "mappings": {
        "Public company|Company limited by shares|Malaysian Financial Reporting Standards": ["FS-MFRS"],
        "Public company|Company limited by shares|Malaysian Private Entities Reporting Standards": ["FS-MPERS"],
        "Public company|Company limited by guarantee|Malaysian Financial Reporting Standards": ["FS-MFRS"],
        "Public company|Company limited by guarantee|Malaysian Private Entities Reporting Standards": ["FS-MPERS"],
        "Public company|Unlimited company|Malaysian Financial Reporting Standards": ["FS-MFRS"],
        "Public company|Unlimited company|Malaysian Private Entities Reporting Standards": ["FS-MPERS"],
        "Private company|Company limited by shares|Malaysian Financial Reporting Standards": ["FS-MFRS"],
        "Private company|Company limited by shares|Malaysian Private Entities Reporting Standards": ["FS-MPERS"],
        "Private company|Company limited by shares|Others": [],
        "Private company|Unlimited company|Malaysian Financial Reporting Standards": ["FS-MFRS"],
        "Private company|Unlimited company|Malaysian Private Entities Reporting Standards": ["FS-MPERS"],
        "Private company|Unlimited company|Others": [],
        "Public company|Company limited by shares|Others": [],
        "Public company|Company limited by guarantee|Others": [],
        "Public company|Unlimited company|Others": []
      }
    },
    "TypesOfDisclosureOnWhetherCompanysSharesAreTraded": {
      "description": "Stock exchange disclosure options based on type of submission",
      "mappings": {
        "FS-MPERS": ["Listed", "Not-listed", "Delisted"],
        "KFI-MFRS": ["Listed", "Not-listed", "Delisted"],
        "FS-MFRS": ["Listed", "Not-listed", "Delisted"],
        "FS-BNM": ["Listed", "Not-listed", "Delisted"],
        "KFI-CLBG": ["Listed", "Not-listed", "Delisted"],
        "FS-CLBG": ["Listed", "Not-listed", "Delisted"]
      }
    },
    "MethodFieldsEnabledByContext": {
      "description": "Method fields enabled based on company status, type, accounting standards, and submission type (4-field filtering). Supports both simple arrays (all enabled) and objects (with disabledWithDefaults).",
      "mappings": {
        "Public company|Company limited by shares|Malaysian Financial Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition"],
        "Public company|Company limited by shares|Malaysian Financial Reporting Standards|FS": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss", "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome", "ssmt:MethodUsedForPreparingStatementOfCashFlows"],
        "Public company|Company limited by shares|Malaysian Private Entities Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity"],
        "Public company|Company limited by shares|Malaysian Private Entities Reporting Standards|FS": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss", "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome", "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity", "ssmt:MethodUsedForPreparingStatementOfCashFlows"],
        "Public company|Unlimited company|Malaysian Financial Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition"],
        "Public company|Unlimited company|Malaysian Financial Reporting Standards|FS": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss", "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome", "ssmt:MethodUsedForPreparingStatementOfCashFlows"],
        "Public company|Unlimited company|Malaysian Private Entities Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity"],
        "Public company|Unlimited company|Malaysian Private Entities Reporting Standards|FS": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss", "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome", "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity", "ssmt:MethodUsedForPreparingStatementOfCashFlows"],
        "Public company|Company limited by guarantee|Malaysian Financial Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition"],
        "Public company|Company limited by guarantee|Malaysian Financial Reporting Standards|FS": {
          "enabled": ["ssmt:MethodUsedForPreparingStatementOfProfitOrLoss"],
          "disabledWithDefaults": {
            "ssmt:MethodUsedForPreparingStatementOfFinancialPosition": "Current-Noncurrent",
            "ssmt:MethodUsedForPreparingStatementOfCashFlows": "Indirect"
          }
        },
        "Private company|Company limited by shares|Malaysian Financial Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition"],
        "Private company|Company limited by shares|Malaysian Financial Reporting Standards|FS": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss", "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome", "ssmt:MethodUsedForPreparingStatementOfCashFlows"],
        "Private company|Company limited by shares|Malaysian Private Entities Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity"],
        "Private company|Company limited by shares|Malaysian Private Entities Reporting Standards|FS": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss", "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome", "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity", "ssmt:MethodUsedForPreparingStatementOfCashFlows"],
        "Private company|Company limited by shares|Others|FS": [],
        "Private company|Unlimited company|Malaysian Financial Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition"],
        "Private company|Unlimited company|Malaysian Financial Reporting Standards|FS": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss", "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome", "ssmt:MethodUsedForPreparingStatementOfCashFlows"],
        "Private company|Unlimited company|Malaysian Private Entities Reporting Standards|KFI": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity"],
        "Private company|Unlimited company|Malaysian Private Entities Reporting Standards|FS": ["ssmt:MethodUsedForPreparingStatementOfFinancialPosition", "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss", "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome", "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity", "ssmt:MethodUsedForPreparingStatementOfCashFlows"],
        "Private company|Unlimited company|Others|FS": ["ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity"]
      }
    }
  }
}
